import apiClient from '$utils/apiClient';
import submitSignedRequestForm from './submitSignedRequestForm';

const LTI_CONSUMER_URL = 'lti-consumer';

const signRequestParameters = async ({ requestData }) => {
  const { data } = await apiClient.post(LTI_CONSUMER_URL, requestData, {
    withCredentials: true,
  });

  return data;
};

const launchTurnitinSubmission = async ({ submissionId, spaceId }) => {
  const signedParams = await signRequestParameters({
    requestData: {
      submissionId,
      spaceId,
    },
  });

  submitSignedRequestForm(signedParams);
};

export default launchTurnitinSubmission;
